<script>
export default {
    name: 'TermsOfService',
    computed: {
        tos() {
            return this.$appConfig('TOS', false)
        },
        privacyPolicy() {
            return this.$appConfig('PRIVACY_POLICY', false)
        },
    },
    methods: {},
}
</script>

<template>
    <div>
        <div>
            <h1><strong>Terms of Service &amp; Privacy Policy</strong></h1>

            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Effective Date: July 28, 2025</p>

            <h2><strong>1. Overview</strong></h2>
            <p>This Terms of Service and Privacy Policy (“Policy”) governs communications initiated through Shift Arcade Ventures LLC (“Shift Arcade Ventures,” “we,” “our,” or “us”), including SMS, email, and other electronic messages sent in connection with:</p>
            <ul>
                <li>General Shift Arcade communications</li>
                <li>Franchise inquiries and franchise-related updates</li>
                <li>Pre-location or network-level customer engagement</li>
            </ul>
            <p>
                Shift Arcade Ventures LLC is the franchisor and brand owner of Shift Arcade. Individual Shift Arcade locations are independently owned and operated businesses. Each location maintains its own Terms of Service and Privacy Policy governing reservations, on-site experiences, payments,
                waivers, and location-specific communications.
            </p>
            <p>Location-specific terms can be found on the respective location websites (for example:</p>
            <p>
                <a href="https://sanramon.shiftarcade.com/privacy-terms"> https://sanramon.shiftarcade.com/privacy-terms </a>
            </p>

            <h2><strong>2. Scope of This Policy</strong></h2>
            <p>This Policy applies when an individual:</p>
            <ul>
                <li>Submits a form on a Shift Arcade or Shift Arcade Ventures website</li>
                <li>Opts in to receive SMS or email communications</li>
                <li>Requests information about Shift Arcade locations or franchise opportunities</li>
                <li>Signs up for updates before a specific location is selected</li>
            </ul>
            <p>Once a customer engages directly with a specific Shift Arcade location (for example, by making a reservation), that location’s own Terms of Service and Privacy Policy will govern the relationship for those services.</p>

            <h2><strong>3. Communications &amp; Messaging Programs</strong></h2>

            <h3><strong>3.1 Purpose of Communications</strong></h3>
            <p>By opting in, individuals may receive informational and service-related messages, including but not limited to:</p>
            <ul>
                <li>Responses to inquiries</li>
                <li>Updates related to Shift Arcade or the Shift Arcade network</li>
                <li>Franchise inquiry follow-ups (for prospective franchisees)</li>
                <li>General customer engagement or informational updates</li>
            </ul>

            <p><strong>Important distinction (for clarity, not separation):</strong></p>
            <ul>
                <li>Franchise inquiries receive communications related only to the franchise discovery process.</li>
                <li>Customer-related communications are limited to general, non-location-specific engagement unless and until the customer engages with a specific location.</li>
            </ul>
            <p>Data collected for franchise inquiries is maintained solely by Shift Arcade Ventures LLC and is not shared with individual franchise locations.</p>

            <h3><strong>3.2 SMS Consent &amp; Opt-Out</strong></h3>
            <p>By opting in to SMS communications, you agree to receive text messages from Shift Arcade Ventures LLC.</p>
            <ul>
                <li>Message frequency varies based on engagement</li>
                <li>Message and data rates may apply</li>
                <li>Carriers are not liable for delayed or undelivered messages</li>
            </ul>
            <p>You may cancel SMS messages at any time by replying <strong>STOP</strong>.</p>
            <p>You may request help by replying <strong>HELP</strong>.</p>
            <p>After opting out, you will receive a confirmation message and no further messages will be sent unless you re-subscribe.</p>

            <h2><strong>4. Information We Collect</strong></h2>
            <p>We may collect the following information when you interact with us:</p>
            <ul>
                <li>Name</li>
                <li>Phone number</li>
                <li>Email address</li>
                <li>Information voluntarily provided through forms or messages</li>
            </ul>
            <p>This information is collected only for legitimate business purposes related to communication, inquiry handling, and customer or franchise engagement.</p>

            <h2><strong>5. How We Use Information</strong></h2>
            <p>Information collected may be used to:</p>
            <ul>
                <li>Respond to inquiries</li>
                <li>Provide requested information</li>
                <li>Communicate updates related to your expressed interest</li>
                <li>Improve communication and support processes</li>
                <li>Maintain compliance with legal and messaging requirements</li>
            </ul>
            <p>We do <strong>not</strong> use this information for unrelated marketing purposes without appropriate consent.</p>

            <h2><strong>6. Data Sharing &amp; Third Parties</strong></h2>
            <p>We do not sell or rent personal information.</p>
            <p>We may use trusted service providers (such as CRM, email, or SMS platforms) solely to support communications and operations. These providers are contractually required to protect data and comply with applicable privacy laws.</p>
            <p><strong>Text messaging opt-in data and consent are never shared</strong>, except with aggregators and providers necessary to deliver messaging services.</p>

            <h2><strong>7. Data Security</strong></h2>
            <p>We take reasonable administrative, technical, and physical measures to protect personal information. While no system can be guaranteed to be 100% secure, we use commercially reasonable safeguards to protect data from unauthorized access or misuse.</p>

            <h2><strong>8. Compliance With Laws</strong></h2>
            <p>We comply with applicable local, state, and federal laws, including mobile messaging regulations and industry standards (including TCPA and CTIA guidelines).</p>
            <p>By participating in our communications, you acknowledge and agree to comply with all applicable laws.</p>

            <h2><strong>9. Changes to This Policy</strong></h2>
            <p>We may update this Policy from time to time. Updates will be posted at:</p>
            <p>
                <strong>
                    <a href="https://shiftarcade.com/privacy-terms"> https://shiftarcade.com/privacy-terms </a>
                </strong>
            </p>
            <p>Continued participation in communications after updates constitutes acceptance of the revised Policy.</p>

            <h2><strong>10. Contact Information</strong></h2>
            <p>For questions regarding this Policy or our data practices, please contact:</p>
            <p><strong>Shift Arcade Ventures LLC</strong></p>
            <p>Email: <strong>franchise@shiftarcade.com</strong></p>
        </div>
        <hr />
        <h2><strong>Apex Club Subscription Terms</strong></h2>

        <h3><strong>Subscription Billing &amp; Minimum Term</strong></h3>
        <p>The Apex Club is a <strong>recurring monthly subscription</strong>. By enrolling in the Apex Club, the customer authorizes Shift Arcade to automatically charge the selected payment method <strong>each month</strong> at the published subscription rate.</p>
        <p>
            All Apex Club subscriptions have a
            <strong>minimum commitment of two (2) months</strong>. The subscription may not be canceled during the initial two-month term.
        </p>
        <p>
            After the minimum term has been satisfied, the subscription will continue on a
            <strong>month-to-month basis</strong> unless canceled by the customer.
        </p>

        <h3><strong>Renewal &amp; Cancellation</strong></h3>
        <p>After the initial two-month minimum term, the customer may cancel the subscription at any time by providing notice through their account or by contacting the location directly.</p>
        <p>Cancellations take effect at the <strong>end of the current billing period</strong>. No partial refunds are issued for unused time, credits, or benefits within a billing period.</p>
        <p>To cancel Apex Club Membership, visit your account dashboard.</p>

        <h3><strong>Credits, Benefits &amp; Usage</strong></h3>
        <p>Subscription benefits, including monthly credits or discounted access, are issued <strong>each billing cycle</strong> and are intended for use during the active subscription period.</p>
        <p>Unused credits or benefits:</p>
        <ul>
            <li>Do not convert to cash</li>
            <li>Are non-transferable</li>
            <li>May expire if the subscription is canceled, depending on the specific Apex Club plan terms</li>
        </ul>
        <p>Subscription benefits are subject to availability and may vary by location.</p>

        <h3><strong>No Refunds for Missed Use</strong></h3>
        <p>
            Failure to use Apex Club benefits during a billing period does not constitute grounds for a refund or credit. The subscription provides
            <strong>access and eligibility</strong>, not guaranteed usage.
        </p>

        <h3><strong>Changes to Subscription Terms</strong></h3>
        <p>Shift Arcade reserves the right to modify Apex Club pricing, benefits, or terms with reasonable notice. Any changes will apply prospectively and will be communicated via email, SMS, or posted terms.</p>

        <h3><strong>Acknowledgement</strong></h3>
        <p>By enrolling in the Apex Club, the customer acknowledges and agrees that:</p>
        <ul>
            <li>The subscription is billed <strong>monthly</strong></li>
            <li>A <strong>two-month minimum term</strong> applies</li>
            <li>Charges will continue automatically unless canceled after the minimum term</li>
        </ul>
    </div>
</template>
